import { render, staticRenderFns } from "./store-performance.vue?vue&type=template&id=01d71728&scoped=true&"
import script from "./store-performance.vue?vue&type=script&lang=js&"
export * from "./store-performance.vue?vue&type=script&lang=js&"
import style0 from "./store-performance.vue?vue&type=style&index=0&id=01d71728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d71728",
  null
  
)

export default component.exports